import * as ActionTypes from '../../../constants/setting/blog'
import update from 'immutability-helper'

const initialState = {
}

export default (state = initialState, action) => {
	switch(action.type) {
		case ActionTypes.RECEIVE_SETTINGS:
			return action.settings.etc

		case ActionTypes.RECEIVE_ETC:
			return action.etc

		default:
			return state
	}
}
